const SendStatusConstants = {
    IN_PROGRESS: 'In progress',
    SUCCESS: 'Sent successfully',
    FAILED: 'Request sending failed'
}

export default SendStatusConstants


